<script>
    import {Route,router} from 'tinro';
    import {Container} from 'svelte-chota';
    import user from './stores/user.js';
    import Top from './cmp/Top.svelte';
    import Loading from './cmp/Loading.svelte';
    import Login from './cmp/Login.svelte';
    import AdminProjects from './cmp/AdminProjects.svelte';
    import AdminProjectsCreate from './cmp/AdminProjectsCreate.svelte';
    import AdminUsers from './cmp/AdminUsers.svelte';
    import AdminUsersCreate from './cmp/AdminUsersCreate.svelte';
    import Projects from './cmp/Projects.svelte';
    import IDE from './cmp/IDE.svelte';
    import Files from './cmp/Files.svelte';

    router.useHashNavigation();
    
    let host = window.location.host;
    let ide = '';
</script>

<div class="wrapper">
    <header><Top/></header>

    <main>
    {#if $user && !$user.error && $router.path.startsWith('/ide/')}
        <Route path="/ide/:project">
            <IDE/>
        </Route>
    {:else}
        <Container class="center-800">
        
            {#if !$user}
                <Loading/>
            {:else if $user.error}
                <Login/>
            {:else}
                <Route path="/" redirect="/projects"/>
                <Route path="/projects"><Projects/></Route>
                <Route path="/files/:project"><Files/></Route>
                {#if $user.admin}
                    <Route path="/admin/*">
                        <Route path="/projects"><AdminProjects/></Route>
                        <Route path="/projects/create"><AdminProjectsCreate/></Route>
                        <Route path="/users"><AdminUsers/></Route>
                        <Route path="/users/create"><AdminUsersCreate/></Route>
                    </Route>
                {/if}
            {/if}
        </Container>    
    {/if}
    </main>
</div>

<style>
    :global(html,body){height: 100%}
    .wrapper{
        height: 100%;
        display: flex;
        flex-direction: column;
    }

    header {
        height: 50px;
    }

    main {
        flex: auto;
    }
</style>